import { render, staticRenderFns } from "./allinpay_bankcard_list.vue?vue&type=template&id=00364506&scoped=true"
import script from "./allinpay_bankcard_list.vue?vue&type=script&lang=js"
export * from "./allinpay_bankcard_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00364506",
  null
  
)

export default component.exports